import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { getUserActivity, type UserActivityParams } from '../services/user-activity.service';

/** Timeline completa con "carica altri" (pagine da 50). */
export function useUserActivity(userId: string | undefined, params: UserActivityParams = {}) {
  return useInfiniteQuery({
    queryKey: ['user-activity', userId, params],
    queryFn: ({ pageParam }) => getUserActivity(userId!, pageParam, params),
    initialPageParam: 1,
    getNextPageParam: (last) => (last.pagination.hasNextPage ? last.pagination.page + 1 : undefined),
    enabled: Boolean(userId),
  });
}

/** Ultimi N eventi, per la card compatta nella scheda utente. */
export function useRecentUserActivity(userId: string | undefined, limit = 5, enabled = true) {
  const params = { limit, recent: true } as const;
  return useQuery({
    queryKey: ['user-activity', userId, params],
    queryFn: () => getUserActivity(userId!, 1, { limit }),
    enabled: Boolean(userId) && enabled,
  });
}
